import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './styles/index.css'
import './styles/oneinc.css'
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
